<wsb-modal
  class="custom-modal-width"
  cancelButtonEnable="true"
  (close)="activeModal.close()"
  (dismiss)="activeModal.dismiss()"
  title="{{ 'send_sms_send_modal' | translate }}"
  (primary)="sendSms()"
  primaryButtonText="common_send"
>
  <div body>
    <div class="">
      <table class="table">
        <tbody>
          <tr>
            <td class="left-column">
              <span>{{'common_messagetype_used' | translate}}</span>
            </td>
            <td class="right-column">{{ quantity }} {{ 'credit_type_' + messageType | translate}}</td>
          </tr>
          <tr>
            <td class="left-column">
              <span>{{'common_recipients' | translate}}</span>
            </td>
            <td class="right-column">{{ recipientsNumber }} {{ 'common_recipient' | translate }}</td>
          </tr>
          <tr>
            <td class="left-column">{{ 'smsadv_summary_settings_config_sendtype' | translate }}</td>
            <td *ngIf="sendingType === 'immediate'" class="right-column">
              {{ 'smsadv_summary_settings_config_sendtype_' + sendingType | translate }}
            </td>
            <td class="left-column" *ngIf="sendingType === 'scheduled'" style="display: grid;" class="right-column">
              <span>{{ 'smsadv_summary_settings_config_sendtype_' + sendingType | translate }}</span>
              <span style="font-size: 14px;">{{ 'sms_detail_sendtime' | translate }} {{ dateTime }}</span>
            </td>
            <td class="left-column" *ngIf="sendingType === 'periodic'" style="display: grid;" class="right-column">
              <span>{{ 'sms_detail_sendtype_periodical' | translate }}</span>
              <span style="font-size: 14px;">{{ 'send_sms_send_start' | translate }}: {{ dateTime }}</span>
              <span style="font-size: 14px;">{{ 'list_sms_tablefield_frequency' | translate }}{{ ': ' }}{{ frequency | translate  }}</span>
              <span style="font-size: 14px;">{{ 'list_sms_tablefield_repeats' | translate }}{{ ': ' }}{{ repeats | translate }}</span>


            </td>
            <td class="left-column" *ngIf="sendingType === 'recurring'" style="display: grid;" class="right-column">
              <span>{{ 'sms_detail_sendtype_dynamic' | translate }}</span>
              <span style="font-size: 14px;">{{ 'list_sms_tablefield_dynamicfield' | translate }}: {{ dynamicField }}</span>
              <span style="font-size: 14px;">{{ 'sms_detail_dyn' + offsetControl + 'pone' | translate }}{{ ': ' }}{{ offset | translate }}</span>
              <span style="font-size: 14px;">{{ 'send_sms_send_time' | translate }}{{ ': ' }}{{ time | translate }}</span>


            </td>
          </tr>
          <tr *ngIf="!senderBlocked">
            <td class="left-column">{{ 'common_sender' | translate }}</td>
            <td class="right-column">{{ sender }}</td>
          </tr>
          <tr>
            <td style="vertical-align: middle;" class="text-row" colspan="2">{{ message }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</wsb-modal>
